import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1300LetztenRestantAendernStatus: 'idle',
    startProcess1300LetztenRestantAendernError: undefined as any,
    loadUserParamsProcess1300LetztenRestantAendernStatus: 'idle',
    loadUserParamsProcess1300LetztenRestantAendernError: undefined as any,

    process1300LetztenRestantAendernList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1300LetztenRestantAendern = createAsyncThunk('process1300LetztenRestantAendernSlice/startProcess1300LetztenRestantAendern', async ({ process1300LetztenRestantAendern }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1300LetztenRestantAendern/`,
        prepareData(process1300LetztenRestantAendern),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1300LetztenRestantAendernStatus } = getState().process1300LetztenRestantAendernSlice
        return startProcess1300LetztenRestantAendernStatus !== 'pending'
    }
})

export const loadUserParamsProcess1300LetztenRestantAendern = createAsyncThunk('process1300LetztenRestantAendernSlice/loadUserParamsProcess1300LetztenRestantAendern', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1300LetztenRestantAendern/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1300LetztenRestantAendernStatus } = getState().process1300LetztenRestantAendernSlice
        return loadUserParamsProcess1300LetztenRestantAendernStatus !== 'pending'
    }
})

const Process1300LetztenRestantAendernSlice = createSlice({
    name: 'process1300LetztenRestantAendernSlice',
    initialState,
    reducers: {
        resetstartProcess1300LetztenRestantAendern: (state) => {
            state.job = undefined
            state.startProcess1300LetztenRestantAendernError = undefined
        },
        resetstartProcess1300LetztenRestantAendernError: (state) => {
            state.startProcess1300LetztenRestantAendernError = undefined
        },
        resetloadUserParamsProcess1300LetztenRestantAendern: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1300LetztenRestantAendernError = undefined
        },
        resetloadUserParamsProcess1300LetztenRestantAendernError: (state) => {
            state.loadUserParamsProcess1300LetztenRestantAendernError = undefined
        },
        removeFromProcess1300LetztenRestantAendernListById: (state, action) => {
            state.process1300LetztenRestantAendernList = state.process1300LetztenRestantAendernList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1300LetztenRestantAendernListByIds: (state, action) => {
            state.process1300LetztenRestantAendernList = state.process1300LetztenRestantAendernList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1300LetztenRestantAendernList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1300LetztenRestantAendernStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1300LetztenRestantAendernList = []
            state.startProcess1300LetztenRestantAendernStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1300LetztenRestantAendern.pending, (state) => {
            state.startProcess1300LetztenRestantAendernStatus = 'pending'
            state.startProcess1300LetztenRestantAendernError = undefined
        })
        builder.addCase(startProcess1300LetztenRestantAendern.fulfilled, (state, action) => {
            state.startProcess1300LetztenRestantAendernStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1300LetztenRestantAendern.rejected, (state, action) => {
            state.startProcess1300LetztenRestantAendernStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1300LetztenRestantAendernError = action.error.message
            } else {
                state.startProcess1300LetztenRestantAendernError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1300LetztenRestantAendern.pending, (state) => {
            state.loadUserParamsProcess1300LetztenRestantAendernStatus = 'pending'
            state.loadUserParamsProcess1300LetztenRestantAendernError = undefined
        })
        builder.addCase(loadUserParamsProcess1300LetztenRestantAendern.fulfilled, (state, action) => {
            state.loadUserParamsProcess1300LetztenRestantAendernStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1300LetztenRestantAendern.rejected, (state, action) => {
            state.loadUserParamsProcess1300LetztenRestantAendernStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1300LetztenRestantAendernError = action.error.message
            } else {
                state.loadUserParamsProcess1300LetztenRestantAendernError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1300LetztenRestantAendern,
    resetstartProcess1300LetztenRestantAendernError,
    resetloadUserParamsProcess1300LetztenRestantAendern,
    resetloadUserParamsProcess1300LetztenRestantAendernError,
    removeFromProcess1300LetztenRestantAendernListById,
    removeFromProcess1300LetztenRestantAendernListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1300LetztenRestantAendernSlice.actions
export default Process1300LetztenRestantAendernSlice.reducer
